import { axios } from '@complispace/cs-design-system';

const baseURL = process.env.QUICK_LINKS_API_URL;
const quickLinksBaseUrl = `${baseURL}/v1/links`;

const quicklink = {
  // GET /links Get all links
  async getLinks(organisation, set) {
    if (set) {
      return axios.get(
        `${quickLinksBaseUrl}?organisation=${organisation}&tag=${set}&order=priority_desc&order=updated_at_desc&skip=0&limit=50`
      );
    }
    return axios.get(
      `${quickLinksBaseUrl}?organisation=${organisation}&order=priority_desc&order=updated_at_desc&skip=0&limit=50`
    );
  },

  // POST /links Create a new link
  async create(link) {
    return axios.post(`${quickLinksBaseUrl}`, link);
  },

  // GET all version
  async getVersions(id, organisation) {
    return axios.get(`${quickLinksBaseUrl}/${id}/versions?organisation=${organisation}`);
  },

  // POST Create version
  async createVersion(link, organisation) {
    return axios.post(
      `${quickLinksBaseUrl}/${link.id}/versions/${link.version}?organisation=${organisation}`,
      link
    );
  },

  // POST Change priority
  async changePriority(link) {
    const obj = {
      organisation: link.organisation,
      priority: link.priority,
      updated_at: new Date()
    };
    return axios.post(`${quickLinksBaseUrl}/${link.id}`, obj);
  },

  // POST Get all links by tags
  async getLinksByTags(organisations, tags) {
    const queryString = Object.keys(organisations)
      .map((key) => `${key}=${organisations[key]}`)
      .join('&');
    return axios.post(`${quickLinksBaseUrl}/tags?${queryString}`, tags);
  }
};

export default quicklink;
